import { LeadScoreCategory } from "../../../types"
import { cn } from "../../utils/classnames"
import { CATEGORY_CONFIG } from "./category-helpers"
import { ReactComponent as FlameIcon } from "../../../assets/icons/flame.svg"

export function getScoreBadgeColor(score: number) {
  if (score >= 80) return "bg-[#3b8358]"
  if (score >= 60) return "bg-[#e7ba19]"
  if (score >= 40) return "bg-primary-400"
  return "bg-neutral-400"
}

interface ScoreBadgeProps {
  score: number
  /** Dashboard preview / compact list */
  variant?: "compact" | "row"
  className?: string
}

export function ScoreBadge({
  score,
  variant = "compact",
  className
}: ScoreBadgeProps) {
  const sizeClass =
    variant === "row"
      ? "h-[68px] w-[53px] px-4 py-3 text-lg"
      : "h-[41px] w-[53px] text-lg"

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-lg font-bold text-white",
        sizeClass,
        getScoreBadgeColor(score),
        className
      )}
    >
      {score}
    </div>
  )
}

interface CategoryChipProps {
  category: LeadScoreCategory
}

export function CategoryChip({ category }: CategoryChipProps) {
  const config = CATEGORY_CONFIG[category]

  if (category === "hot_lead") {
    return (
      <span className="inline-flex shrink-0 items-center gap-1 rounded-sm border border-rose-100 bg-rose-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.45px] text-rose-600">
        <FlameIcon className="h-[9px] w-2 shrink-0" aria-hidden="true" />
        {config.label}
      </span>
    )
  }

  return (
    <span
      className={`badge ${config.badgeClass} shrink-0 text-[9px] uppercase tracking-[0.45px]`}
    >
      {config.label}
    </span>
  )
}
